import React from 'react'

import { type HomepageContent } from '../../types'
import styles from './styles.module.scss'

type DataEnabledInvestigationsProps = {
  content: HomepageContent['dataEnabledInvestigations']
}

const DataEnabledInvestigations = ({ content }: DataEnabledInvestigationsProps) => (
  <section className={styles.section} aria-labelledby="data-enabled-investigations-title">
    <div className={styles.content}>
      <div className={styles.intro}>
        <h2 id="data-enabled-investigations-title">{content.title}</h2>
        <p>{content.description}</p>
      </div>
      <div className={styles.items}>
        {content.items.map((item) => (
          <article key={item.title} className={styles.item}>
            <span aria-hidden />
            <div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
    <img className={styles.image} src={content.image} alt={content.imageAlt || ''} />
  </section>
)

export default DataEnabledInvestigations
